<template>
    <div>
        <span v-if="showLabel">{{field.label}}:</span>
        {{ getFieldValue }}
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object
      },
      field: {
        type: Object,
        required: true
      },
      showLabel: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      getFieldValue () {
        if (this.item === null) {
          return ''
        }

        let value = this.item[this.field.handle].value
        const options = this.item[this.field.handle].options

        if (Array.isArray(value) === false) {
          value = [value]
        }
        let selected = []
        value.forEach(value => {
          const s = options.find(option => option.value === value)
          if (typeof s !== 'undefined') {
            selected.push(s.label)
          }
        })

        return selected.join(', ')
      }
    },
    name: 'Relations'
  }
</script>

<style scoped>

</style>